module.exports = __webpack_public_path__ + "static/media/paw-claws.bacde5ad.svg";